// ====================================================
// Promotion Start Time
// ====================================================

if (new Date() >= new Date('2026-07-06T10:00:00+08:00')) {
  (() => {
    /*
    $(".sale7 .free_gift_banner, .sale7 .groupsell-wrap-second").addClass(
      "show",
    );
    */
    ("use strict");

    const prodHandle = location.pathname.split("/").pop();

    // ================================
    // PRODUCT GROUPS (SAFE WHITELIST)
    // ================================
    /*
  
  
    const airconProducts = [
      "prism-neo"
    ]
  
  
    */
      //FREE INSTALLATION
      /*
    
    */
    //FIXED MOUNT
    /*
    const FixedMount43to100 = [
      "q43u-2026",
      "q55u-2026",
      "q65u-2026",
      "u55-2026",
      "u65-2026",
    ];
    */
    /*
    //TILTED MOUNT
    const TiltedMount55to86 = [
      "q75u-2026",
      "q85u-2026",
      "prism-q100-ultra-qled-google-tv",
      "u75-2026",
      "u75-qled-mini-led-google",
      "prism-u86-qd-mini-led"
    ];
    */
    const ceilingFanProducts = ["oasis-pro", "oasis-pro-macaron"];
    //FREE SOUNDBAR - UULTRA
    const FreeRipple = [
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-55al-google-tv",
      "prism-65al-google-tv",
      "u75-qled-mini-led-google"
    ];
    const FreeFixedMount = ["prism-u55-ultra-qd-mini-led-4k-ai-google-tv"];

    //TV UPSIZE
    const roam27upsize = ["prism-roam-27"];
    const roam27ultraupsize = ["prism-roam-ultra-27"];
    //MONITORS UPSIZE
    const monitor49AL = ["prism-49al"];
    const monitor49AL240hz = ["prism-49al-240hz"];
    //VACUUMS
    const Evosonic = ["prism-evosonic-ultra"];
    const EvosonicAquamarine = ["evosonic-ultra-detect-aquamarine"];
    const nanobot = ["prism-nanobot"];
    const nanobotPro = ["prism-nanobot-pro"];
    const nanobotElite = ["prism-nanobot-elitemm-ai"];
    //FRIDGE
    const FridgeAura = [
      "prism-purefresh-fdr-440-four-door-refrigerator",
      "purefresh-fdr-570",
      "prism-purefresh-sbs600-refrigerator",
      "purefresh-sbsi-560",
    ];
    const FridgePriceDrop = [
      "purefresh-tmf-250",
      "prism-purefresh-tmf330-refrigerator",
      "prism-purefresh-tmf420-refrigerator",
      "prism-evershine-tmf420-refrigerator",
      "prism-evershine-tmf530-refrigerator",
      "purefresh-bmf-330",
    ];

    const FreeAura = ["aura-smart-air-purifier"];
    const FreeVortex = ["prism-vortex"];
    const FreeVortexPro = ["prism-vortex-pro"];
    /*
    const FreeEvosonicUltra = [
      "prism-cyclone-washer-dryer-bundle",
      "prism-washer-dryer-bundles",
      "laundry-rack-and-washer-bundle"
    ]
    const FreeEvosonicPro = [
      "prism-solaris",
      "prism-solaris-pro"
    ]
    */
      //Locks
      /*
    const freeLocks = [
      "prism-sentinel-bundle-2026",
      "prism-spectre-bundle-2026"
    ]
    */

    // ================================
    // HELPERS
    // ================================
    function createBanner(img, title, desc, extra = "", freeTag = "8.8 NATIONAL DAY SALE") {
      const wrapper = document.createElement("div");
      wrapper.className = "free_gift_banner layout2";

      wrapper.innerHTML = `
        <div class="free-gift">
        <img src="${img}" alt="">
        <div class="info-wrapper">
            <div class="title-wrapper">
            <span class="free-tag">${freeTag}</span>
            <span class="title">${title}</span>
            </div>
            ${desc ? `<p class="description">${desc}</p>` : ""}
            <span class="description red">${extra}</span>
        </div>
        </div>
    `;

      return wrapper;
    }

    // ================================
    // BANNERS
    // ================================
    /*
    function getCeilingFanInstallBanner() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CFs_Desktop_cd7a14f0-d8da-4b5b-9180-85c8e15f33f1.png?v=1780035893",
        `5% OFF 2 Ceiling Fans | 8% OFF 3 Ceiling Fans`,
        `Only for Oasis Pro and Oasis Pro Macaron`,
        `Offer Ends 12 July`,
      );
    }
    /*
    function getAirconNeoInstallBanner() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ACFreebie.png?v=1777691605",
        `FREE Chemical Wash (Worth up to $650)`,
      );
    }
    */

    //FIXED MOUNT
    /*
    function getFixedMount43to100() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/FixedMount_Desktop_92ef1f6d-8b66-4153-b483-c2d7d501249c.png?v=1780035892",
        `Free Fixed Mount (worth $299)`,
        `Only for Q-Ultra & U Series TV`,
      );
    }
    function getFixedMountU55U() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/FixedMount_Desktop_92ef1f6d-8b66-4153-b483-c2d7d501249c.png?v=1780035892",
        `Free Fixed Mount (worth $299)`,
        `Only for the U55 Ultra`,
        "",
        "EXCLUSIVE PRE-ORDER PROMO"
      );
    }

    //TILTED MOUNT
    function getTiltedMount55to86() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TiltedMount_Desktop_7f0208f2-43f1-4b7c-89c3-8a06524b1aa0.png?v=1780035892",
        `Free Tilted Mount (worth $299)`,
        `Only for Q-Ultra & U Series TV`,
      );
    }
    */
    //RIPPLE SOUNDBAR
    function getFreeRippleSoundbar() {
      $(".saleboxwrap.add-on-prism-ripple").addClass("hide");
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Ripple_Desktop_c4bc25e8-280f-4c48-b75a-562ac39f735b.png?v=1780035892",
        `Free Ripple Soundbar (Worth $999)`,
        `Only for U Ultra & AL OLED TVs`,
        "Offer Ends 9 August",
      );
    }

    //ROAM UPSIZE
    function getRoam27upsize() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Roam27_Desktop_0364b8fb-0f33-4993-a729-47e57ffef987.png?v=1780035892",
        `$300 OFF Upsized Discount`,
        `<s>$200</s> $300 OFF every purchase of a Roam 27`,
        `Offer Ends 12 July`,
      );
    }
    function getRoam27ultraupsize() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Roam27_Desktop_0364b8fb-0f33-4993-a729-47e57ffef987.png?v=1780035892",
        `$350 OFF Upsized Discount`,
        `<s>$200</s> $350 OFF every purchase of a Roam Ultra 27`,
        `Offer Ends 12 July`,
      );
    }
    //MONITOR UPSIZE
    function getMonitor49AL() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/49-al-greycallout.png?v=1780586635",
        `$230 OFF Upsized Discount`,
        `<s>$70</s> $230 OFF every purchase of a 49AL`,
        `Offer Ends 12 July`,
      );
    }
    function getMonitor49AL240hz() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/49240hz-al-greycallout.png?v=1780586635",
        `$210 OFF Upsized Discount`,
        `<s>$70</s> $210 OFF every purchase of a 49AL 240hz`,
        `Offer Ends 12 July`,
      );
    }

    //VACUUMS
    function getEvosonic() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoHub_Desktop_72ca2659-e022-4188-8048-dacef88fc66d.png?v=1780586502",
        `Free HEPA Filter (Worth $29.90)`,
        `With every Evosonic Ultra Detect Elite Accessories.`,
        `Offer Ends 12 July`,
      );
    }
    function getEvosonicAquamarine() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoHub_Desktop_72ca2659-e022-4188-8048-dacef88fc66d.png?v=1780586502",
        `Free HEPA Filter (Worth $29.90)`,
        `With every EvoSonic Ultra Detect AquaMarine & Prime Accessories`,
        `Offer Ends 12 July`,
      );
    }
    function getNanobot() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBot_Desktop_263634af-de99-4a5d-aaeb-3fdbf698ae7e.png?v=1780624661",
        `$230 OFF Upsized Discount`,
        `<s>$200</s> $230 OFF every purchase of a NanoBot`,
        `Offer Ends 12 July`,
      );
    }
    function getNanobotPro() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotPro_Desktop_b3e2e325-e98a-43aa-b549-220d23afd5b9.png?v=1780025550",
        `$250 OFF Upsized Discount`,
        `<s>$200</s> $250 OFF every purchase of a NanoBot`,
        `Offer Ends 12 July`,
      );
    }
    function getNanobotElite() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotEliteAI_Desktop_5df36fdd-9a8c-46e7-8b4b-1d7af2596612.png?v=1780624725",
        `Free 2x Cleaning Solution (Worth $19.90)`,
        `With every purchase of a NanoBot Elite AI`,
        `Offer Ends 12 July`,
      );
    }
    //Fridge
    function getFreeAura() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/2Aura_Desktop_b486648b-0439-4a1c-b250-475d3da8dfde.png?v=1783066292",
        `FREE Aura Replacement Filter (Worth $48)`,
        `Only for Aura Air Purifier`,
        `Offer Ends 12 July`,
      );
    }
    function getVortex() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/2Aura_Desktop_b486648b-0439-4a1c-b250-475d3da8dfde.png?v=1783066292",
        `FREE Vortex Replacement Filter (Worth $57)`,
        `Only for Vortex Air Purifier`,
        `Offer Ends 12 July`,
      );
    }
    function getVortexPro() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/2Aura_Desktop_b486648b-0439-4a1c-b250-475d3da8dfde.png?v=1783066292",
        `FREE Vortex Pro Replacement Filter (Worth $67)`,
        `Only for Vortex Pro Air Purifier`,
        `Offer Ends 12 July`,
      );
    }
    function getFridgePriceDrop() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Fridges_Desktop_e12df44d-9e64-457e-ba4b-499e7dd9175d.png?v=1780035892",
        `Limited Time Price Drop`,
        `Only available with selected fridge models`,
      );
    }
    //Laundry
    function getFreeEvosonicUltra() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoSonicUltra_Desktop_45b7e430-0fcf-4d0f-aad8-9d00c29de2b2.png?v=1780035892",
        `Free EvoSonic Ultra Detect Handheld Vacuum (Worth $299)`,
        `Only for Washer & Dryer , Laundry Rack & Washer Bundle`,
      );
    }
    function getFreeEvosonicPro() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoSonicPro_Desktop_dbdca161-f759-4e88-8ec5-1a024bfb8083.png?v=1780035893",
        `Free EvoSonic Pro Handheld Vacuum (Worth $229)`,
        `Only for Solaris Pro & Solaris Pro XL`,
      );
    }
    //LOCKS
    function getFreeLocks() {
      return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SmartDoorbell_Desktop_40ec5c31-9f68-491a-b9fb-5e2989fb588b.png?v=1780035892",
        `Free Scout Doorbell (worth $299)`,
        `Only for Sentinel & Spectre Bundle 2026`,
        ` · First 50 purchases only`,
      );
    }
    // ================================
    // LOGIC
    // ================================
    let banner = null;

    /*
  
    }else if (FixedMount43to100.includes(prodHandle)) {
      banner = getFixedMount43to100();
    }else if (TiltedMount55to86.includes(prodHandle)) {
      banner = getTiltedMount55to86();
    }else 
      else if (FreeEvosonicUltra.includes(prodHandle)) {
      banner = getFreeEvosonicUltra();
    }else if (FreeEvosonicPro.includes(prodHandle)) {
      banner = getFreeEvosonicPro();
    }else if (freeLocks.includes(prodHandle)) {
      banner = getFreeLocks();
    }
    */
    if (ceilingFanProducts.includes(prodHandle)) {
      banner = getCeilingFanInstallBanner();
    } else if (roam27upsize.includes(prodHandle)) {
      banner = getRoam27upsize();
    } else if (roam27ultraupsize.includes(prodHandle)) {
      banner = getRoam27ultraupsize();
    } else if (Evosonic.includes(prodHandle)) {
      banner = getEvosonic();
    } else if (EvosonicAquamarine.includes(prodHandle)) {
      banner = getEvosonicAquamarine();
    } else if (nanobot.includes(prodHandle)) {
      banner = getNanobot();
    } else if (nanobotPro.includes(prodHandle)) {
      banner = getNanobotPro();
    } else if (nanobotElite.includes(prodHandle)) {
      banner = getNanobotElite();
    } else if (FreeAura.includes(prodHandle)) {
      banner = getFreeAura();
    } else if (FreeVortex.includes(prodHandle)) {
      banner = getVortex();
    } else if (FreeVortexPro.includes(prodHandle)) {
      banner = getVortexPro();
    } else if (FridgePriceDrop.includes(prodHandle)) {
      banner = getFridgePriceDrop();
    } else if (monitor49AL.includes(prodHandle)) {
      banner = getMonitor49AL();
    } else if (monitor49AL240hz.includes(prodHandle)) {
      banner = getMonitor49AL240hz();
    } else if (FreeRipple.includes(prodHandle)) {
      banner = getFreeRippleSoundbar();
    } else if (FreeFixedMount.includes(prodHandle)) {
      banner = getFixedMountU55U();
    }

    if (!banner) return;

    // ================================
    // INJECT
    // ================================
    function inject() {
      const target =
        document.querySelector('[itemprop="offers"]') ||
        document.querySelector(".variant-selector") ||
        document.querySelector(".product-form");

      if (!target) return;

      target.parentNode.insertBefore(banner, target);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", inject);
    } else {
      inject();
    }

    $(function () {
      const allowedProducts = [
        "prism-49al-240hz-8662946447587",
        "prism-49al-8662946316515",
      ];

      const productId = $("body").attr("id");

      if (allowedProducts.includes(productId)) {
        $(".free_gift_banner").each(function () {
          if (!$(this).next(".cart-hdden").length) {
            $(this).insertAfter(".cart-hdden");
          }
        });
      }
    });
  })();
}


$(document).ready(function () {

  // Only run when .sale7 exists
  if (!$(".sale7").length) return;


  // =========================
  // FREE GIFT BANNER
  // =========================

  $(".free_gift_banner .title").text(
    "Bundle a Solaris XL Laundry Rack for $199 only (Worth $729)"
  );

  $(".free_gift_banner .description").each(function () {

    const $description = $(this);

    // Only target the main description, not .description.red
    if ($description.hasClass("red")) return;

    $description.html(`
      Applicable for all Fridges except for PureFresh MB50 &amp; MB90
      <br>
      <span class="description red">Offer Ends 12 July</span>
    `);

  });


  // =========================
  // GROUPSELL HEADING
  // =========================

  $(".groupsell-wrap-second h3.text-left").text(
    "7.7 Exclusive Add-on: Laundry Rack for $199 (worth $729)"
  );


// =========================
// SOLARIS XL TOP-UP PRICE
// =========================

$(".groupsell-wrap-second .box-solaris-xl .prodprice2").each(function () {

  const $priceWrap = $(this);

  // Remove duplicate labels previously added by this script
  $priceWrap.find(".data-topup-price").remove();

  // Only add one if the existing HTML has no "Top up" label
  const hasTopupLabel = $priceWrap
    .children()
    .filter(function () {
      return $(this).text().trim() === "Top up";
    })
    .length > 0;

  if (!hasTopupLabel) {
    $priceWrap.prepend(`
      <span
        class="data-topup-price"
        style="color: #000; font-weight: 500;"
        data-topup-price="199"
      >
        Top up
      </span>
    `);
  }

  $priceWrap
    .find(".newprice")
    .text("$199")
    .attr("data-price", "199");

});


});